import React from 'react';
import {FormattedMessage} from 'react-intl';
import CSSModules from 'react-css-modules';
import contactUsUrl from 'utils/url/contactUsUrl';
import styles from './documentFailure.scss';

@CSSModules(styles, {allowMultiple: true})
export default class DocumentFailure extends React.Component {
  render() {
    const failMessage = 'purchase.document.error';
    const contactUsLink = <a href={contactUsUrl()} target="_blank"><FormattedMessage id="common.link.contactUs.text"/></a>;

    return (
      <div styleName="documentFailure">
        <FormattedMessage id={failMessage} values={{contactUsLink}}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pdf/DocumentFailure.js